<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>胸卡列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="basicMsg">
      <ul>
        <li>
          <span>可申请证件数量：</span>
          <span><b style="color:red;">{{ticketNumObj.totalTicketNum}}</b>张</span>
        </li>
        <li>
          <span>已提交证件数量：</span>
          <span><b style="color:green;">{{ticketNumObj.submittedTicketNum}}</b>张</span>
        </li>
      </ul>
    </div>
    <div class="operas">
      <el-button type="primary" @click="addCard">新增</el-button>
    </div>
    <el-table
      v-if="isPC"
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="tktName"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="tktComName"
        label="公司名">
      </el-table-column>
      <el-table-column
        label="头像"
        width="160">
        <template slot-scope="scope">
          <img style="max-height:100px;" :src="scope.row.photo"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="tktPassportNo"
        label="身份证号">
      </el-table-column>
      <el-table-column
        prop="tktRank"
        label="职位">
      </el-table-column>
      <el-table-column
        prop="tktMobile"
        label="手机号">
      </el-table-column>
      <el-table-column
        label="操作"
        width="160">
        <template slot-scope="scope">
          <el-button @click="editCard(scope.row)" type="text" size="small" v-if="!scope.row.tktIfTreat">修改</el-button>
          <el-button @click="deletCard(scope.row)" type="text" size="small" v-if="!scope.row.tktIfTreat">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <ul v-else class="cards">
      <li v-for="(val) in tableData" :key="val.id">
        <div :body-style="{ padding: '0px' }" class="cardItem">
          <div class="img"><img :src="val.photo"></div>
          <div class="rightBox">
            <p>姓名： {{val.tktName}}</p>
            <p>公司名： {{val.tktComName}}</p>
            <p>身份证号： {{val.tktPassportNo}}</p>
            <p>职位： {{val.tktRank}}</p>
            <p>手机号： {{val.tktMobile}}</p>
            <div class="bottom clearfix">
              <el-button class="button" type="primary" @click="editCard(val)">修改</el-button>
              <el-button class="button" @click="deletCard(val)">删除</el-button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import tools from '../../utils/tools.js';
export default {
  name: 'card',
  data() {
    return {
      tableData: [],
      isPC: true,
      ticketNumObj: {},
    }
  },
  mounted() {
    this.isPC = tools.isPC()
    this.getTicket()
    this.getticketnum()
  },
  methods: {
    getticketnum () {
      api.getticketnum({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          this.ticketNumObj = res.data.data
          this.overlayshow = false
        } else if (res.data.code === 900) {
          // this.$toast.fail('登录超时！')
          this.$notify({
            title: '错误',
            message: '登录超时！',
            type: 'error'
          });
          this.$router.push('/')
        }
      })
    },
    addCard() {
      if (this.ticketNumObj.totalTicketNum > this.ticketNumObj.submittedTicketNum) {
        this.$router.push({path: '/addCard', query: {type: 'add'}})
      } else {
        // this.$toast.fail('证件数量已达上限')
        this.$notify({
          title: '警告',
          message: '证件数量已达上限！',
          type: 'warning'
        });
      }
    },
    deletCard(row) {
      this.$confirm('确定删除该证件？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        api.deleteticket({tktID: ''+row.tktID}).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            });
            this.getTicket()
          }
        })
      }).catch(() => {});
    },
    resetForm() {
      this.ruleForm={
        tktName: '',
        tktComName: '',
        photo: '',
        tktPassportNo: '',
        tktRank: '',
        tktMobile:''
      }
    },
    getTicket() {
      api.ticketlist().then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data
        }
      })
    },
    editCard(row, type) {
      this.$router.push({path: '/addCard', query: {type: 'edit', tktID: row.tktID}})
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .operas{
    text-align: right;
    padding: 20px 0;
  }
  .fileParent {
    position: relative;
    img {
      position: absolute;
      width: 60px;
      height: 39px;
      left: 0;
      top: 0;
    }
  }
  .file {
    position: absolute;
    left: 0;
    opacity: 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  .basicMsg{
    margin-top:0.2rem;
    font-size: 14px;
    li{
      padding:5px 10px;
      span:nth-child(1){
        color:#999;
      }
      b{
        font-size:16px;
        padding: 0 10px;
      }
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:120px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
